module.exports = __webpack_public_path__ + "static/17-915c956e306dd57a46e863387933bb42.png";